document.addEventListener("DOMContentLoaded", function () {
  const highlight = document.querySelector(".key-markets-archive__underline");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id");
        const linkElement = document.querySelector(`a[href="#${id}"]`);
        const parent = linkElement.parentNode;
        if (entry.isIntersecting) {
          if (parent && !parent.classList.contains("active")) {
            parent.classList.add("active");

            setMobileTextContent(parent.textContent);

            if (highlight) {
              highlightNavLink(linkElement, highlight);
            }
          }
        } else {
          if (parent && parent.classList.contains("active")) {
            parent.classList.remove("active");
          }
        }
      });
    },
    {
      rootMargin: "-49% 0px -51%",
      root: document,
    }
  );

  // only select key market headers that have an id on them
  const keyMarketHeaders = document.querySelectorAll(".key-markets-header[id]");

  if (keyMarketHeaders && keyMarketHeaders.length) {
    keyMarketHeaders.forEach((header) => {
      observer.observe(header);
    });

    // other logic in here for setting the text content of the in markets dropdown
    const activeKeyMarketHeader = document.querySelector(
      ".key-markets-archive__nav-item.active"
    );

    const navToggleButton = document.querySelector(
      ".key-markets-archive__mobile-nav-toggle .current"
    );

    if (activeKeyMarketHeader && navToggleButton) {
      navToggleButton.textContent = activeKeyMarketHeader.textContent;

      const link = activeKeyMarketHeader.querySelector("a");

      if (highlight) {
        highlightNavLink(link, highlight);
      }
    }
  }

  function setMobileTextContent(text) {
    const navToggleButton = document.querySelector(
      ".key-markets-archive__mobile-nav-toggle .current"
    );

    if (navToggleButton) {
      navToggleButton.textContent = text;
    }
  }
});

function highlightNavLink(element, highlight) {
  const OVERFLOW_WIDTH = 2;
  const OFFSET_WIDTH = -1;
  const OFFSET_HEIGHT = 10;

  highlight.style.width = `${element.clientWidth - OVERFLOW_WIDTH}px`;
  highlight.style.transform = `translate(${
    element.offsetLeft - OFFSET_WIDTH
  }px, -${element.offsetTop - OFFSET_HEIGHT}px)`;
}
